/**
 * Created by yibrahim on 13/07/2017.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthorizationGuardService} from '@westjetairlines/wjesd-oauth2-library';
import {EditComponent} from './edit.component';
import {ReservationStepComponent} from '../steps/reservation-step/reservation-step.component';
import {CreditStepComponent} from '../steps/credit-step/credit-step.component';
import {GuestCreditStepComponent} from '../steps/guest-credit-step/guest-credit-step.component';
import {AgencyStepComponent} from '../steps/agency-step/agency-step.component';
import {TravelCreditTypeResolver} from '../shared/resolvers/travel-credit-type.resolver';
import {TravelCreditType} from '../shared/models/travel-credit-type';
import {Roles} from '../shared/models/roles';
import {TravelCreditActionResolver} from '../shared/resolvers/travel-credit-action.resolver';

const editChildRoutes: Routes = [
  {
    path: 'reservation-step',
    component: ReservationStepComponent,
    data: {stepNumber: 1, previousStep: null,  nextStep: '../credit-step'}
  },
  {
    path: 'credit-step',
    component: CreditStepComponent,
    data: {stepNumber: 2, previousStep: '../reservation-step',  nextStep: '../guest-credit-step'}
  },
  {
    path: 'guest-credit-step',
    component: GuestCreditStepComponent,
    data: {stepNumber: 3, previousStep: '../credit-step',  nextStep: '../agency-step'}
  },
  {
    path: 'agency-step',
    component: AgencyStepComponent,
    data: {stepNumber: 4, previousStep: '../guest-credit-step',  nextStep: null}
  }
];

const editFavorsSteps = [
  {
    stepNumber: 1,
    name: 'Reservation'
  },
  {
    stepNumber: 2,
    name: 'Reason'
  },
  {
    stepNumber: 3,
    name: 'Verification'
  },
  {
    stepNumber: 4,
    name: 'Agency and Sales'
  }
];

const editWaiverSteps = [
  {
    stepNumber: 1,
    name: 'Reservation'
  },
  {
    stepNumber: 2,
    name: 'Reason'
  },
  {
    stepNumber: 3,
    name: 'Verification'
  },
  {
    stepNumber: 4,
    name: 'Agency and Sales'
  }
];

const editWaiverRoutes: Routes = [
  {
    path: 'waivers/:id',
    component: EditComponent,
    canActivate: [AuthorizationGuardService],
    children: editChildRoutes,
    data: { travelCreditTypeId: TravelCreditType.WaiverId, roles: [Roles.WaiversAdmin], steps: editFavorsSteps },
    resolve: {
      travelCreditAction : TravelCreditActionResolver,
      travelCreditType: TravelCreditTypeResolver
    }
  }
];

const editFavorRoutes: Routes = [
  {
    path: 'favours/:id',
    component: EditComponent,
    canActivate: [AuthorizationGuardService],
    children: editChildRoutes,
    data: { travelCreditTypeId: TravelCreditType.FavourId, roles: [Roles.FavoursAdmin],  steps: editWaiverSteps },
    resolve: {
      travelCreditAction : TravelCreditActionResolver,
      travelCreditType: TravelCreditTypeResolver
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(editWaiverRoutes),
    RouterModule.forChild(editFavorRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    TravelCreditTypeResolver,
    TravelCreditActionResolver
  ]
})
export class EditRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/edit/edit-routing.module.ts